<template>
    <div class="table-container-item">
    <span class="table-header" v-if="header">
        {{header}}
    </span>
    <div class="table-container">
        <div class="table-content">
            <div class="sub-header flex gap-10" v-if="subheader">
                <slot name="header-parts"></slot>
                <h4 class="table-title">{{ subheader }}</h4>
                <slot name="filter-parts"></slot>

            </div>
            <table class="table-list">

            <thead>
                <tr>
                    <th v-for="(item, index) in headers" :key="`${index}-${item.name}-${header}`">
                        {{item.name}}
                    </th>
                    <th v-if="actions && actions.length > 0" :key="`actions-${header}`" class="flex justify-end">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data" :key="`${index}-${item.name}`" @click="$emit('row-click', item);" :class="`${type}`">
                    <td v-for="(td_item, td_index) in headers" :key="`row-${td_index}-${td_item.name}`">
                        <router-link 
                            v-if="item[td_item.link_field]" 
                            :to="{
                                name: 'bo_user', 
                                params: {'id': item[td_item.link_field] },
                                props: true
                            }">{{item[td_item.key]}}</router-link>
                        <span v-else-if="td_item.type == 'button'">
                            <button class="button w-content" @click.stop="$emit('button-click', {item, td_item})">
                                {{ 
                                    td_item.format ? 
                                    td_item.format(item[td_item.key]) 
                                    : 
                                    item[td_item.key] 
                                }}
                            </button>
                        </span>                        
                        <span v-else-if="td_item.type == 'xml-file'">
                            <div class='attachment' @click="$emit('downloadFile', item)">
                                <img src="@/assets/excel-file.svg" class='fileicon'>
                                <div class="filename flex row align-start gap-10">
                                    <div class="name-holder">
                                        <div class="name-of-the-file">{{ item.filename }}</div>
                                        <div class="size-of-the-file">{{ Utils.calculateFileSize(item.filesize) }}</div>
                                    </div>
                                    <img src="@/assets/download.svg" class='download'>

                                </div>
                                </div>
                        </span>
                        <span v-else-if="td_item.type == 'file-xml'">
                            <div class='attachment'>
                                <img src="@/assets/file.svg" class='fileicon'>
                                <div class="filename">
                                    <div class="name-of-the-file">{{ td_item.format ? 
                                        td_item.format(item[td_item.key]) 
                                        : 
                                        item[td_item.key]  }}</div>
                                    <div class="size-of-the-file">{{ item.template_type }}</div>
                                </div>
                            </div>
                        </span>
                        <span v-else-if="td_item.type == 'download'">
                            <img src="@/assets/download.svg" class='download-icon' @click.stop="$emit('downloadFile', item)">
                        </span>
                        
                        <span v-else>
                            {{ 
                                td_item.format ? 
                                td_item.format(item[td_item.key]) 
                                : 
                                item[td_item.key] 
                            }}

                        </span>
                    </td>
                    <td v-if="actions && actions.length > 0" :key="`actions-${index}`">
                        <div class="action-container flex justify-end">
                            <img 
                                v-for="(action, action_index) in actions" 
                                :src="icons[action]" class='icon' @click.stop="$emit(action, item)"
                            >
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class='no-data-present no-data-presents' v-if="data && data.length == 0">
          Nothing here yet
        </div>
    </div>

    </div>
    </div>
</template>
  
<script setup>
  // @ is an alias to /src
  


    const icons = {
        download: require('@/assets/download.svg'),
        delete: require('@/assets/delete.svg'),
    }

    import Utils from '@/utils/index.js';
    import { defineProps } from 'vue';

    const props = defineProps({
        data: Array,
        header: String,
        subheader: String,
        headers: Array,
        type: String,
        actions: Array
    })


</script>

<style scoped lang="scss">

    .table-header {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        text-align: left;
        color: black;
    }
    .table-container-item {
        display: flex;
        max-width: 1350px;
        width: 100%;
        flex-direction: column;
    }
    .table-container {
        width: 100%;
    }
    .table-content {
        min-width: 100%;
        border: 1px solid #ccc;
        border-radius: 10px;
        width: fit-content;
    } 
    .sub-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        padding: 20px;
        padding-left: 30px;
        display: flex;
        align-items: center;
        background-color: white;
    }
    .action-container {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
    .table-title {
        display: flex;
        justify-content: space-between;
        color: black;
        font-size: 20px;
    }
    .table-list {
        padding: 20px;
        width: 100%;
        border-collapse: collapse;

        th, td {
            padding: 15px;
            text-align: left;
            border: none;
            padding-left: 15px;
            color: black;
        }
        td {
            padding-top: 19px;
            padding-bottom: 19px;
        }
        th {
            text-align: left;
            border: none;
        }
        tr {
            border-top: 1px solid #ccc;
        }
        tbody {
            tr {
                cursor: pointer;
                td {
                    background: white;
                }

                &:last-child {
                    td {
                        &:first-child {
                            border-bottom-left-radius: 10px;
                        }
                        &:last-child {
                            border-bottom-right-radius: 10px;
                        }
                    }
                }
                &:hover {
                    td {
                        background: #f9f9f9;
                    }
                }
            }
        }
    }
    h4 {
        margin: 0;
    }
 
    .attachment {
        border-radius: .5rem;
        border-width: 1px;
        -moz-column-gap: .5rem;
        column-gap: .5rem;
        padding: .8rem;
        display: flex;
        align-items: center;
        padding-left: 0;
    }
    .message-attachments {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    .size-of-the-file {
        font-size: 0.8rem;
        color: rgb(116 119 127);
    }
    .name-of-the-file {
        display: flex;
        align-items: center;
        color: black;
        font-size: 0.9rem;

        text-align: left;
        overflow: hidden;
        text-wrap: nowrap;
        text-overflow: ellipsis;
    }
    .fileicon {
        width: 40px;
        height: 40px;
    }
    .padding-small td{
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .attachment {
        .download {
            display: none;
        }
        .name-holder {
            padding-right: 25px;
        }
        &:hover {
            .download {
                display: block;
            }
            .name-holder {
                padding-right: 0px;
            }
        }
    }
    .icon {
        padding: 0 10px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .actions {
        text-align: right;
    }

</style>